export default "__VITE_ASSET__DgGJs6pc__"